import {
  type CurrentUser,
  selectInitialized,
  selectIsAuthenticated,
  selectUser,
  useAuthStore,
} from './auth-store';

interface UseAuthResult {
  user: CurrentUser | null;
  initialized: boolean;
  isAuthenticated: boolean;
}

export function useAuth(): UseAuthResult {
  const user = useAuthStore(selectUser);
  const initialized = useAuthStore(selectInitialized);
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  return { user, initialized, isAuthenticated };
}
